// extracted by mini-css-extract-plugin
export default {"title":"text_title__lT+mL","title__wrapper":"text_title__wrapper__bZWZP"};